import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';

const host = document.getElementById('root');
if (!host) throw new Error('#root is missing from index.html');

createRoot(host).render(
  // StrictMode is deliberate. It double-invokes render and effects in development, which
  // is how a launcher that registers a window handle or holds state across clicks reveals
  // a double-mount defect here rather than in a consumer's application.
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
